export const NODE_ENV_LOCAL = 'local';
export const NODE_NEV_DEV = 'development';
export const NODE_ENV_STG = 'staging';
export const NODE_ENV_PROD = 'production';
